// extracted by mini-css-extract-plugin
export default {"bar-chart-wrapper":"BarChartComponent_bar-chart-wrapper__CtUzi","title":"BarChartComponent_title__djiGJ"};